import { clientIds } from '@/lib/constants';
import { getKeyFromSelector } from '@/lib/i18n';
import { anyDocumentSchema, phoneNumberSchema } from '@/lib/validation/schemas';
import * as z from 'zod';

const erroSoftware = getKeyFromSelector(
  $ => $.testeGratis.erros.softwareNaoEncontrado,
  { ns: 'public' },
);
const erroRevenda = getKeyFromSelector(
  $ => $.testeGratis.erros.revendaNaoEncontrada,
  { ns: 'public' },
);

const parametrosTesteGratisOriginaisSchema = z.object({
  // Client id do sistema do teste grátis.
  // Só permite PontoWeb por enquanto
  t: z
    .int({
      error: erroSoftware,
    })
    .refine(value => value.toString() === clientIds.pontoWeb, {
      error: erroSoftware,
    }),

  // Id da revenda
  r: z.coerce.number({ error: erroRevenda }).min(1, { error: erroRevenda }),

  // Duração do teste grátis. Está vulnerável a manipulação, será revisto futuramente
  d: z.coerce.number().min(1).max(40).catch(40),

  // Email do usuário que será vinculado ao banco do teste.
  // Normalmente é o email de oportunidades da Secullum ou email de alguém da revenda.
  // Também está vulnerável, deve ser revisto futuramente
  e: z.email().trim().optional().catch(''),

  // Usado pelo Marketing para identificar a campanha de onde veio o usuário do teste grátis
  c: z.string().trim().optional().catch(''),
});

// Por compatibilidade, os valores dos params de busca precisam ser passados como
// 't', 'r', 'd', 'e' e 'c'
// porém não é semântico, então transformamos em um formato melhor de se trabalhar
export const parametrosTesteGratisSchema =
  parametrosTesteGratisOriginaisSchema.transform(params => ({
    clientId: params.t.toString(),
    revendaId: params.r,
    duracaoEmDias: params.d,
    emailContaVinculadaPadrao: params.e,
    campanha: params.c,
  }));

export const cadastrarTesteGratisSchema = z.object({
  documento: anyDocumentSchema,
  razaoSocial: z.string().trim().min(1).max(100),
  contatoNome: z.string().trim().min(1).max(200),
  contatoTelefone: phoneNumberSchema,
  contatoEmail: z
    .string()
    .trim()
    .min(1)
    .and(
      z.email({
        // Essa é a regex usada no Secullum.Validation, que é usado na api do autenticador
        // https://github.com/Secullum/Secullum.Validation/blob/master/src/Secullum.Validation/Validation.cs#L209
        pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
      }),
    ),
});

export type ParametrosTesteGratisSchema = z.infer<
  typeof parametrosTesteGratisSchema
>;
export type CadastrarTesteGratisSchema = z.infer<
  typeof cadastrarTesteGratisSchema
>;
